import styled from "styled-components";
import { VectorSpotLight } from "../../shared/icons";
export const HeroSectionWrapper = styled.div`
  background: #1e440b url(${VectorSpotLight}) no-repeat top center;
  background-size: cover;
  padding: 80px 0 100px;
`;
export const HeroContentWrapper = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  h1 {
    color: #fff;
    font-size: calc(2.1vw + 20px);
    font-weight: 400;
    padding-top: 20px;
  }
  p {
    color: #fff;
    padding: 10px 0;
  }
`;
export const LiveSectionWrapper = styled.div`
  padding: 50px 0;
`;
export const LiveContentWrapper = styled.div`
  ul {
    padding: 0;
    list-style: none;
    display: flex;
    border: 1px solid #1e440b;
    margin: 30px 0 0;
    flex-wrap: wrap;
    li:first-child {
      flex: 1.3 1.3 0;
      img {
        max-width: 100%;
        height: 100%;
      }
    }
    li:last-child {
      background: #1e440b;
      margin: 20px 20px 20px 40px;
      padding: 50px 80px;
      flex: 1.5 1.5 0;
      h2 {
        color: #fff;
        font-size: calc(1.1vw + 20px);
        font-weight: 400;
      }
      p {
        color: #fff;
        margin-top: 0;
        padding: 10px 0;
        span {
          position: relative;
          padding-left: 20px;
          border-radius: 50px;
          padding: 10px 20px;
          border: 1px solid #ff9d59;
          background: #34601e;
          display: inline-block;
          &:before {
            content: "";
            position: absolute;
            left: 10px;
            top: 0;
            bottom: 0;
            background: red;
            width: 6px;
            height: 6px;
            margin: auto;
            border-radius: 50px;
          }
        }
      }

      div {
        display: flex;
        align-items: center;
        gap: 10px;
        span {
          font-family: "Sora", sans-serif;
          color: #fff;
        }
        button {
          margin-right: 10px;
        }
      }
    }
  }
`;
